// extracted by mini-css-extract-plugin
export var modalFooter = "_iv-0";